import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { ErrorBoundary } from './app/ErrorBoundary';
import { openDB } from './db/db';
import { installErrorCapture } from './app/feedback';
import { installFx } from './app/confirm';
import { installDisplay } from './app/display';
import { installLicenceGuard } from './app/licence';
import { installUpdates } from './app/update';
import { installA2HS } from './app/recommend';
import { installStats } from './app/stats';
import './styles.css';

installLicenceGuard();
// Android/Chrome: dlouhý stisk na odkazu nebo obrázku otevírá kontextovou nabídku
// (Otevřít v Chromu, Kopírovat odkaz…). V aplikaci ji potlačíme – kromě vstupních
// polí a textů ke zkopírování. (Na iPhonu to řeší CSS -webkit-touch-callout.)
document.addEventListener('contextmenu', (e) => {
  const t = e.target as HTMLElement | null;
  if (t?.closest('input, textarea, select, [contenteditable], .selectable')) return;
  e.preventDefault();
});
installErrorCapture();
installFx();
installDisplay();
// ťuknutí na upozornění (schránka autora): service worker řekne, kam přejít
navigator.serviceWorker?.addEventListener('message', (e: MessageEvent) => {
  const d = e.data as { type?: string; url?: string } | null;
  if (d?.type === 'open' && d.url) {
    const h = new URL(d.url).hash;
    if (h) location.hash = h;
  }
});

openDB()
  .then(() => {
    try {
      sessionStorage.removeItem('vcely-recovered');
    } catch {
      /* nevadí */
    }
    createRoot(document.getElementById('root')!).render(
      <StrictMode>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </StrictMode>,
    );
  })
  .catch((e) => {
    document.getElementById('root')!.innerHTML =
      '<p style="padding:24px;font:16px system-ui">Nepodařilo se otevřít úložiště dat. ' +
      'Zkontrolujte, že prohlížeč není v anonymním režimu.<br><small>' +
      String(e?.message ?? e) +
      '</small></p>';
  });

// Offline režim a aktualizace: service worker uloží aplikaci do mezipaměti
// a hlídá novou verzi.
installUpdates();
installA2HS();
installStats();
